export default {"src":"/_next/static/media/boop.3f5bfdc2.svg","height":250,"width":250};